/* eslint-disable react/no-children-prop */
import React, { Fragment, useState } from 'react';
import {
	Card, CardBody, Row, Col
} from 'reactstrap';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';

import { Tooltip } from '@material-ui/core';

import { Field, reduxForm, getFormValues, change } from 'redux-form';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Modal from '../../../shared/components/Modal';

import TrialSubscribe from './../../../shared/components/payment/TrialSubscribe';
import ChangePlan from '../../../shared/components/payment/ChangePlan';
import CoinIcon from 'mdi-react/StarCircleOutlineIcon';
import QuickStartGuide from '../../../shared/components/QuickStartGuide';
import PremiumCreditIcon from 'mdi-react/PlusCircleMultipleOutlineIcon';
import StandardCreditIcon from 'mdi-react/CircleDoubleIcon';

import {
	_capitalizeText,
	_formatNumber
} from '../../../shared/helpers/utils';

import { subscriptionPlans, appFeatures, DataCreditUsageProgress } from '../../../shared/components/payment/plans.js';
import PremiumCreditsPurchaseModal from '../../../shared/components/premium_credits/PremiumCreditsPurchaseModal';
import AutoRechargeSettings from '../../../shared/components/premium_credits/AutoRechargeSettings';

const required = function (value) { return value ? undefined : 'Required'; };
const maxLength = function (max) {
	return function (value) {
		return value && value.length > max ? 'Must be ' + max + ' characters or less' : undefined;
	};
};
const maxLength15 = maxLength(15);
const number = function (value) { return value && isNaN(Number(value)) ? 'Must be a number' : undefined; };
const minValue = function (min) {
	return function (value) {
		return value && value < min ? 'Must be at least ' + min : undefined;
	};
};
const minValue18 = minValue(18);
const email = function (value) {
	return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
		'Invalid email address' : undefined;
};

const renderTextField = function (props) {
	var input = props.input;
	var label = props.label;
	var meta = props.meta || {};
	var touched = meta.touched;
	var error = meta.error;
	var warning = meta.warning;
	var children = props.children;
	var select = props.select;

	return (
		<Fragment>
			<TextField
				className="material-form__field"
				label={label}
				error={touched && error}
				value={input.value}
				children={children}
				select={select}
				onChange={function (e) {
					e.preventDefault();
					input.onChange(e.target.value);
				}}
				type="password"
			/>
			{touched && ((error && <div className="field-error">{error}</div>) || (warning && <div className="field-error warn">{warning}</div>))}
		</Fragment>
	);
};

renderTextField.propTypes = {
	input: PropTypes.shape().isRequired,
	label: PropTypes.string,
	meta: PropTypes.shape({
		touched: PropTypes.bool,
		error: PropTypes.string,
	}),
	select: PropTypes.bool,
	children: PropTypes.arrayOf(PropTypes.element),
};

renderTextField.defaultProps = {
	label: '',
	meta: null,
	select: false,
	children: [],
};

const DataUsageForm = function (props) {
	var _useState = useState(false);
	var modalOpen = _useState[0];
	var setModalOpen = _useState[1];

	var _useState2 = useState(false);
	var subscribe = _useState2[0];
	var setSubscribe = _useState2[1];

	var _useState3 = useState(false);
	var planOpen = _useState3[0];
	var setPlanOpen = _useState3[1];

	var cancelSubscription = props.cancelSubscription;
	var reset = props.reset;
	var user = props.user;
	var subscription = props.subscription;
	var reactivateSubscription = props.reactivateSubscription;
	var userCreditUsed = props.userCreditUsed;
	var message = props.message;

	var subscriptionPlan = user && user.subscriptionPlan ? user.subscriptionPlan : null;
	var currentPlan = subscriptionPlans.filter(function (plan) {
		return plan.stripeProductId === subscriptionPlan;
	})[0];

	if (!currentPlan) {
		currentPlan = subscriptionPlans.filter(plan => user.role.includes(plan.id) ||
			(plan.altIds && plan.altIds.some(altId => user.role.includes(altId))))[0];
	}

	var dataCredits = 0;

	if (currentPlan && currentPlan.dataCredits) {
		dataCredits = currentPlan.dataCredits;
	} else if (user && user.role && user.role.indexOf('admin') >= 0) {
		dataCredits = 9999999;
	}



	if (typeof user.monthlyDataCreditOverride === 'number' && user.monthlyDataCreditOverride >= 0) {
		dataCredits = user.monthlyDataCreditOverride;
	}

	// Standard credits usage
	var creditsUsed = userCreditUsed || 0;
	var creditsRemaining = dataCredits - creditsUsed;
	if (creditsRemaining < 0) {
		creditsRemaining = 0;
	}

	// Premium credits balance
	var premiumCreditsBalance = 0;
	if (typeof user.premiumCredits === 'number') {
		premiumCreditsBalance = user.premiumCredits;
	}
	var premiumCreditsRemaining = premiumCreditsBalance;

	return (
		<Col md={12} lg={12}>
			<Card className="billing">
				<CardBody>
					<div>
						<h5 className="bold-text card__title mb-1">
							<CoinIcon size={36} /> Credit Usage
						</h5>
						<QuickStartGuide
							link="http://help.marketproof.com/en/articles/13454433-understanding-credits-in-marketproof-pro"
							type="credits"
							linkCopy="Understanding Credits in Marketproof Pro"
						/>
						<hr />
					</div>

					{/* Premium Credits — full width with purple tint */}
					<Row>
						<Col md={12} className="mb-3">
							<Card>
								<CardBody className="billing-credits__card billing-credits__card--premium" style={{ background: 'linear-gradient(to right, #F9F5FF, #ffffff)', borderRadius: 8 }}>
									<div className="billing-credits__header">
										<h6 className="billing-credits__section-title">
											Premium Credits
										</h6>
										<span className="billing-credits__badge billing-credits__badge--premium">
											Never expires
										</span>
									</div>

									<p className="billing-credits__section-description">
										Premium Credits <strong>unlock high-value content</strong> such as contact emails, phone numbers, owner profiles and true owners behind LLCs. They <strong>never expire</strong> and are purchased separately from your subscription.
									</p>
									<hr />

									<Row>
										{/* Column 1 — Balance & Purchase */}
										<Col md={6}>
											<div className="billing-credits__summary billing-credits__summary--premium">
												<div className="billing-credits__stat billing-credits__stat--highlight">
													<div className="billing-credits__stat-label">
														Premium Credits Available
													</div>
													<div className="billing-credits__stat-value billing-credits__stat-value--emphasis">
														{_formatNumber(premiumCreditsRemaining)}
													</div>
													<div className="billing-credits__stat-sub">
														used for enhanced features
													</div>
												</div>
											</div>
											<div className="billing-premium__actions" style={{ marginTop: 16 }}>
												<PremiumCreditsPurchaseModal
													renderButton={function (btnProps) {
														return (
															<Button
																variant="contained"
																color="primary"
																onClick={btnProps.onClick}
																className="billing-premium__buy-button"
															>
																Buy Premium Credits
															</Button>
														);
													}}
													onConfirm={function (selectedPack, done) {
														// selectedPack.credits
														// selectedPack.pricePerCredit
												// Call done() when finished if you want to stop the spinner.
											}}
										/>
									</div>
										</Col>

										{/* Column 2 — Auto-Recharge */}
										<Col md={6}>
											<div style={{ padding: 16, height: '100%', background: '#fff', border: '1px solid #d6c4ff', borderRadius: 8 }}>
												<AutoRechargeSettings />
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>

					{/* Standard Credits — full width */}
					<Row>
						<Col md={12} className="mb-3">
							<Card>
								<CardBody className="billing-credits__card">
									<div className="billing-credits__header">
										<h6 className="billing-credits__section-title">
											Standard Credits
										</h6>
										<span className="billing-credits__badge">
											Resets Monthly
										</span>
									</div>

									<p className="billing-credits__section-description">
										Standard Credits are <strong>included with your Marketproof Pro plan</strong>. You receive a set amount each billing month that covers standard data exports. When the billing month resets, <strong>your standard credits reset</strong> as well.
									</p>
									<hr />
									<div className="billing-credits__summary">
										<div className="billing-credits__stat">
											<div className="billing-credits__stat-label">Included In Your Plan</div>
											<div className="billing-credits__stat-value">
												{_formatNumber(dataCredits)}
											</div>
											<div className="billing-credits__stat-sub">
												total standard credits
											</div>
										</div>

										<div className="billing-credits__stat">
											<div className="billing-credits__stat-label">Used</div>
											<div className="billing-credits__stat-value">
												{_formatNumber(creditsUsed)}
											</div>
											<div className="billing-credits__stat-sub">
												so far this month
											</div>
										</div>

										<div className="billing-credits__stat billing-credits__stat--highlight">
											<div className="billing-credits__stat-label">
												Remaining
											</div>
											<div className="billing-credits__stat-value billing-credits__stat-value--emphasis">
												{_formatNumber(creditsRemaining)}
											</div>
											<div className="billing-credits__stat-sub">
												credits left this month
											</div>
										</div>
									</div>
									<hr />
									<div className="billing-credits__progress-wrapper">
										<DataCreditUsageProgress
											credit_total={dataCredits}
											credit_used={creditsUsed}
											usage
										/>
									</div>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</Col>
	);
};

const form = 'password_form';

export default connect(
	function (state, props) {
		var initalValues = Object.assign({}, props.user);
		return {
			initialValues: Object.assign({}, initalValues),
			formValues: getFormValues(form)(state),
			user: state.user
		};
	}
)(reduxForm({
	form: form
})(DataUsageForm));
